import { WA_NUMBER, WA_MESSAGES, GUIDE_NAME } from '../../constants'
import { reviews } from '../../data/reviews'

export default function TrekBookingRail({ trek }) {
  const trekReviews = reviews.filter(r => r.trek === trek.name)
  const rated = trekReviews.filter(r => r.rating)
  const avg = rated.length ? rated.reduce((s, r) => s + r.rating, 0) / rated.length : 5
  const waMessage = WA_MESSAGES[trek.waKey] || WA_MESSAGES.general
  const waHref = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(waMessage)}`

  const trustBullets = [
    ...(trek.trustSignals || []),
    ...(trekReviews.length ? [`Real reviews (${trekReviews.length})`] : []),
  ]

  return (
    <>
      {/* Desktop sticky rail */}
      <aside className="mobile-hidden" style={{ position: 'sticky', top: '100px' }}>
        <div style={{
          background: 'var(--stone)', padding: '32px', borderRadius: 'var(--radius-lg)',
          border: '1px solid var(--stone-mid)', marginBottom: '16px',
        }}>
          <div style={{ fontSize: '12px', letterSpacing: '1px', textTransform: 'uppercase', color: 'var(--green)', fontWeight: 600, marginBottom: '8px' }}>
            Direct Booking
          </div>
          <div style={{ fontSize: '28px', fontWeight: 600, color: 'var(--ink)', marginBottom: '4px' }}>
            {trek.priceFrom
              ? <>from ${trek.priceFrom.toLocaleString()} <span style={{ fontSize: '14px', color: 'var(--ink-light)', fontWeight: 400 }}>USD</span></>
              : <span style={{ fontSize: '20px' }}>Price on request</span>}
          </div>
          <div style={{ fontSize: '13px', color: 'var(--ink-mid)', marginBottom: '12px' }}>
            {trek.duration} days / {trek.duration - 1} nights
          </div>

          <a href="#reviews" style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', color: 'var(--ink-mid)', marginBottom: '20px' }}>
            <span style={{ color: 'var(--color-accent-cool)' }}>{'★'.repeat(Math.round(avg))}</span>
            See all reviews →
          </a>

          <a href={waHref} target="_blank" rel="noreferrer" className="btn btn-green" style={{ width: '100%', justifyContent: 'center', height: '48px', marginBottom: '20px' }}>
            WhatsApp to Book
          </a>

          {trustBullets.length > 0 && (
            <>
              <div style={{ height: '1px', background: 'var(--stone-mid)', marginBottom: '16px' }} />
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {trustBullets.map(t => (
                  <div key={t} style={{ fontSize: '12px', display: 'flex', alignItems: 'center', gap: '8px', color: 'var(--ink-mid)' }}>
                    <span style={{ color: 'var(--green)', fontWeight: 900 }}>✔</span>
                    {t}
                  </div>
                ))}
              </div>
            </>
          )}
        </div>

        {/* Guide mini-card */}
        <div style={{
          background: 'var(--white)', border: '1px solid var(--stone-mid)', borderRadius: 'var(--radius-lg)',
          padding: '20px', display: 'flex', alignItems: 'center', gap: '12px',
        }}>
          <div style={{
            width: '44px', height: '44px', borderRadius: '50%', background: 'var(--green)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white',
            fontWeight: 600, fontSize: '18px', fontFamily: 'var(--serif)', flexShrink: 0,
          }}>
            {GUIDE_NAME.charAt(0)}
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: '13px', fontWeight: 600 }}>{GUIDE_NAME}</div>
            <div style={{ fontSize: '11px', color: 'var(--ink-light)' }}>{trek.guideRole || 'Local guide'}</div>
          </div>
          <a href={waHref} target="_blank" rel="noreferrer" aria-label="Message on WhatsApp" style={{ color: 'var(--green)', flexShrink: 0, display: 'flex' }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
              <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.123 1.528 5.862L0 24l6.335-1.527A11.945 11.945 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.849 0-3.587-.504-5.083-1.385l-.364-.215-3.76.906.923-3.68-.237-.378A9.946 9.946 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/>
            </svg>
          </a>
        </div>
      </aside>

      {/* Mobile condensed sticky bottom bar */}
      <div className="sticky-bottom-bar">
        <div>
          <div style={{ fontSize: '11px', color: 'var(--ink-light)' }}>{trek.priceFrom ? 'from' : ''}</div>
          <div style={{ fontSize: '17px', fontWeight: 600, color: 'var(--ink)' }}>
            {trek.priceFrom ? `$${trek.priceFrom.toLocaleString()} USD` : 'Price on request'}
          </div>
        </div>
        <a href={waHref} target="_blank" rel="noreferrer" className="btn btn-green" style={{ flexShrink: 0 }}>
          WhatsApp to Book
        </a>
      </div>
    </>
  )
}
